import React from 'react'
import Pagetitle from './../components/pagetitle/Pagetitle'
import Projectstart from './../components/projectstart/Projectstart'
export default function Jobs() {
  return (
    <div>
      <Pagetitle pagename="Jobs" parentpage="Home" />
      <Projectstart Projecttitle="Jobs" projectdescription="Do you want to work for a leading Software House where the customer is always at the center of attention? Apply Now to secure a position at iHunar." projectbtntext="Apply Now" />
    </div>
  )
}
